<template>
  <header class="md:hidden bg-noir-800/95 backdrop-blur-md border-b border-gold-500/20 p-4 flex justify-between items-center sticky top-0 z-30">
    <div class="flex items-center gap-3">
      <button
        @click="$emit('toggleSidebar')"
        class="text-cream-200/70 hover:text-gold-400 transition-colors"
        aria-label="Toggle sidebar"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      <h1 class="text-lg font-bold font-display text-gold-400">TFS Admin</h1>
    </div>

    <div class="flex items-center gap-3">
      <NotificationIcon />
      <LanguageSwitcher />
      <div class="text-sm text-right hidden sm:block">
        <p class="font-medium text-cream-100">{{ user?.name || 'User' }}</p>
        <p class="text-cream-200/50 text-xs">{{ user?.email || '' }}</p>
      </div>
      <button
        @click="$emit('logout')"
        class="text-sm text-burgundy-400 hover:text-burgundy-300 font-medium transition-colors"
      >
        Logout
      </button>
    </div>
  </header>
</template>

<script setup lang="ts">
import LanguageSwitcher from '@/sites/tfs/components/layout/LanguageSwitcher.vue';
import NotificationIcon from '@/sites/tfs/components/notifications/NotificationIcon.vue';
import type { UserEntity } from '@/modules/auth/domain/entities/User';

type Props = {
  user?: UserEntity | null;
};

type Emits = {
  (e: 'toggleSidebar'): void;
  (e: 'logout'): void;
};

withDefaults(defineProps<Props>(), {
  user: null,
});

defineEmits<Emits>();
</script>
